import { ResponseCode } from '@/common/request/types';
import { useAppRouter } from '@/common/route/useAppRouter';
import { useRouteQuery } from '@/common/route/useRouteQuery';
import { pageSize } from '@/common/utils/helpers';
import { useBaseListView } from '@/common/view/useBaseListView';
import { ROUTE_NAME_DUPLICATE } from '@/modules/duplicate/router';
import { useGameMatchList } from '@/modules/game/match/model/list';
import { duplicateService } from '@/services/duplicate';

export function useDuplicateCycleList() {
    const router = useAppRouter();

    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            offset: { type: 'number', default: 0 },
            limit: { type: 'number', default: pageSize }
        },
        onChange: () => fetchList()
    });

    const { fetchAllMatches, gameMatchCache } = useGameMatchList();

    const { list, total, fetchList } = useBaseListView({
        request: duplicateService.cycle.list,
        paramsBuilder: () => ({ ...query }),
        hooks: {
            loadInitialData: async () => await fetchAllMatches(),
            onPageChange: offset => (query.offset = offset),
            onSuccess: updateQueryToRoute,
            transformResponse: async (list: any[]) => {
                const itemIds = new Set(list.map(cycle => cycle.duplicateItemId));
                const itemResponse = await duplicateService.item.getList(Array.from(itemIds).join(','));
                if (itemResponse.code === ResponseCode.Ok) {
                    const mapItems = new Map<number, any>(itemResponse.data.map((item: any) => [item.id, item]));

                    return list.map(cycle => {
                        const item = mapItems.get(cycle.duplicateItemId);
                        return {
                            ...cycle,
                            itemName: item?.name,
                            itemGame: item?.game,
                            matchId: item?.matchId,
                            matchName: gameMatchCache.value.get(item?.matchId)?.label
                        };
                    });
                } else {
                    router.push({ name: ROUTE_NAME_DUPLICATE.ITEM.INDEX });
                    return [];
                }
            }
        }
    });

    return { list, total, query, fetchList };
}
